export default __webpack_public_path__ + "static/30-15a2d23fcaeb39b4e2bb09fe86aaaff3.jpg";